import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import Table from "./MenuCompo/Table";
import Call from "./MenuCompo/Call";
import Anchor from "./MenuCompo/Anchor";
import NewAnchor from "./MenuCompo/NewAnchor";
import TopNot from "./MenuCompo/TopNot";
import Not from "./MenuCompo/Not";
import Footer from "./MenuCompo/Footer";
import PCWEB from "./PC/PCWEB";
import CallService from "./CallService/CallService";
import Nagasaki from "./MenuChoice/MenuSelect";
import Lang from "./Lang/Lang";
import { useCookies } from 'react-cookie';
import Menu from "./MenuCompo/Menu";
import useTokenStore from "./Store/Store";
import axios from "axios";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import CompanyInfo from "./MenuCompo/CompanyInfo";
import FirstAlert from "./FirstAlert/FirstAlert";

const Styled = {
  PCWrap:styled.div`
    width: 500px;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  `,
  Wrap: styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  `,
  Header: styled.div`
    width: 100%;
    height: auto;
    position: fixed;
    top: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-color:#ffffff;
    z-index:3;
  `,
  Notice: styled.div`
    width: 248px;
    height: 51px;
    border-radius: 10px;
    background-color: #2277F6;
    display: ${({ display }) => (display ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.5s ease-in-out;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
  `,
  NoticeText: styled.p`
    font-size: 14px;
    font-weight: 400;
    margin: 0px;
    font-family: 'PreFont400';
    color:#ffffff;
  `,
  MarginTopBox:styled.div`
    width:100%;
    height:${(props) => (props.isFixed ? "70px" : "0px")};
  `,
};

const Order = () => {
  const { Pocket, PocketNum, setPocketNum } = useTokenStore();
  const { id } = useParams();
  const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
  const [RestaurantInfo, setRestaurantInfo] = useState(undefined)
  const [Table_PK, setTable_PK] = useState(undefined)
  const [TableInfo, setTableInfo] = useState(undefined)
  const [isLoading, setIsLoading] = useState(true);
  const [IDcookies, setIDcookies, removeIDcookies] = useCookies(['restaurant_id']);
  const [AlertOpen, setAlertOpen] = useState(true)

  const [isFixed, setIsFixed] = useState(false); // 스크롤 상태 관리

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        window.location.reload(); // 새로고침
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
        setIsFixed(window.scrollY >= 100); // 스크롤이 90px 이상이면 true
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // 클린업
  }, []);
  // 스크롤관리

  useEffect(() => {
    if (!id) return;
  
    // 무조건 실행
    const first = id.substring(0, 36);     // Restaurant_PK
    const second = id.substring(36);       // Table_PK
  
    setRestaurant_PK(first);
    setTable_PK(second);
  
    const currentCookieID = IDcookies['restaurant_id'];
  
    if (currentCookieID !== id) {
      // id가 변경된 경우: 쿠키 업데이트 + 캐시 초기화 + 새 요청
      setIDcookies('restaurant_id', id, { path: '/', maxAge: 60 * 60 * 24 * 365 });
      localStorage.removeItem("restaurant_data");
      
      RestaurantCheck2(first); // Restaurant_PK 전달

      TableCheck2(second)
    }
  }, [id]);

  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [PC, setPC] = useState(false);
  const [CallOpen, setCallOpen] = useState(false);
  const [LangSetting, setLangSetting] = useState(false);
  const [NowLang, setNowLang] = useState("KR");
  const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
  const [showNotification, setShowNotification] = useState(false);
  const [restaurantLocation, setRestaurantLocation] = useState({ lat: 0, lng: 0 });

  const resizeListener = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeListener);
    setNowLang(Langcookies["PageLang"]);
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  useEffect(() => {
    if (Langcookies["PageLang"] === undefined) {
      setLangCookie("PageLang", "KR", { path: "/", maxAge: 60 * 60 * 24 * 365 });
    }
  }, [Langcookies["PageLang"]]);

  useEffect(() => {
    if (innerWidth > 800) {
      setPC(true);
    }
  }, [innerWidth]);

  useEffect(() => {
    if (Pocket && Pocket.length > 0 && PocketNum !== Pocket.length) {
      setPocketNum(PocketNum + 1);
      setShowNotification(true); // 알림창을 보이도록 설정
      setTimeout(() => setShowNotification(false), 1500); // 1.5초 후에 알림창 숨기기
    }
  }, [Pocket]);

  const axiosInstance = axios.create({
      baseURL: 'https://zzikgomainapi.co.kr/',
  });

  const RestaurantCheck = async () => {
    try {
      const response = await axiosInstance.get("business/restaurant/"+Restaurant_PK+"/");
      console.log(response.data)
      setRestaurantInfo(response.data)
      setRestaurantLocation({
        lat: response.data.latitude,
        lng: response.data.longitude
      })
      const dataWithExpiry = {
        data: response.data,
        expiresAt: Date.now() + 30 * 60 * 1000 // 현재 시간 + 30분
      };
      localStorage.setItem("restaurant_data", JSON.stringify(dataWithExpiry));
      setIsLoading(false)
    } catch (error) {
      console.error(error); // 요청에 실패한 경우 에러 메시지 출력
    }
  };

  const RestaurantCheck2 = async (value) => {
    try {
      const response = await axiosInstance.get("business/restaurant/"+value+"/");
      console.log(response.data)
      setRestaurantInfo(response.data)
      setRestaurantLocation({
        lat: response.data.latitude,
        lng: response.data.longitude
      })
      const dataWithExpiry = {
        data: response.data,
        expiresAt: Date.now() + 30 * 60 * 1000 // 현재 시간 + 30분
      };
      localStorage.setItem("restaurant_data", JSON.stringify(dataWithExpiry));
      setIsLoading(false)
    } catch (error) {
      console.error(error); // 요청에 실패한 경우 에러 메시지 출력
    }
  };
  const TableCheck = async () => {
    try {
      const response = await axiosInstance.get("business/table/" + Table_PK + "/");
      console.log("📦 TableCheck 응답 데이터:", response.data);
      setTableInfo(response.data);
    } catch (error) {
      console.error("❌ TableCheck 에러:", error);
    }
  };
  const TableCheck2 = async (value) => {
    try {
      const response = await axiosInstance.get("business/table/" + value + "/");
      console.log("📦 TableCheck 응답 데이터:", response.data);
      setTableInfo(response.data);
    } catch (error) {
      console.error("❌ TableCheck 에러:", error);
    }
  };

  useEffect(()=>{
    console.log(RestaurantInfo)
  }, [RestaurantInfo])
  
  useEffect(() => {
    const loadData = async () => {
      if (Restaurant_PK === undefined || Table_PK === undefined) return;
  
      // 1. 레스토랑 데이터 먼저 처리
      const savedData = localStorage.getItem("restaurant_data");
      if(id){
        console.log(id)
      }
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);

          if (parsed.expiresAt && parsed.expiresAt > Date.now()) {
            setRestaurantInfo(parsed.data);
            setRestaurantLocation({ lat: parsed.data.latitude, lng: parsed.data.longitude });
            await TableCheck();
            setIsLoading(false);
          } else {
            // 데이터가 만료됨
            localStorage.removeItem("restaurant_data");
            await RestaurantCheck();
          }
        } catch (err) {
          localStorage.removeItem("restaurant_data");
          await RestaurantCheck();
        }
      } else {
        await RestaurantCheck();
      }
      // 2. 테이블 정보 가져오기
    };
    // RestaurantCheck();
    loadData();
  }, [Restaurant_PK, Table_PK, id]);
  

// 레스토랑 로딩




  const [Message, setMessage] = useState({
    "KR":"메뉴가 장바구리에 추가되었습니다",
    "EN":"The menu has been added to the cart",
    "CN":"菜单已添加到购物车",
    "JP":"メニューがカートに追加されました",
    "FR":"Le menu a été ajouté au panier.",
    "SP":"El menú se ha añadido al carrito",
    "GR":"Das Menü wurde zum Warenkorb hinzugefügt",
    "RU":"Меню добавлено в корзину"
})

const Skeleton = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #f0f0f0;
  animation: skeleton-loading 1.5s infinite ease-in-out;
  
  @keyframes skeleton-loading {
    0% {
      background-color: #f0f0f0;
    }
    50% {
      background-color: #e0e0e0;
    }
    100% {
      background-color: #f0f0f0;
    }
  }
`;
useEffect(()=>{
  if(PC === true){
    alert("모바일로 접속해주세요 테스트 기간동안 PC접속을 허용중입니다.")
  }
},[])



  const [isScrolled, setIsScrolled] = useState(false);
  const wrapRef = useRef(null);

  const handleScroll = () => {
    if (wrapRef.current) {
      const scrollTop = wrapRef.current.scrollTop;
      setIsScrolled(scrollTop > 94);
    }
  };

  useEffect(()=>{
    console.log(isScrolled)
  }, [isScrolled])

  useEffect(() => {
    const wrapElement = wrapRef.current;
    if (!wrapElement) return;

    wrapElement.addEventListener('scroll', handleScroll);
    return () => wrapElement.removeEventListener('scroll', handleScroll);
  }, []);

  return(
    PC ? (
      // <PCWEB />
      // 가로로 돌리면 pc버전으로 나오고 새로고침을 해야함.

      <Styled.Wrap ref={wrapRef}>
        <CallService CallOpen={CallOpen} setCallOpen={setCallOpen} NowLang={NowLang} setNowLang={setNowLang} />
        <Lang setLangSetting={setLangSetting} LangSetting={LangSetting} NowLang={NowLang} setNowLang={setNowLang} />
        {isLoading ? (
          <Skeleton />
        ) :<></> }
        {AlertOpen ? (
          <FirstAlert setAlertOpen={setAlertOpen} AlertOpen={AlertOpen} restaurantLocation={restaurantLocation} />
        ) : <></>}
        <TopNot />
        <Styled.Header>
          <Call setCallOpen={setCallOpen} setLangSetting={setLangSetting} NowLang={NowLang} />
        </Styled.Header>


        {isLoading ? (
          <Skeleton /> // 로딩 중일 때 스켈레톤 화면 표시
        ) : (
          <>
            <Table RestaurantInfo={RestaurantInfo} TableInfo={TableInfo} />
            <NewAnchor 
              isScrolled={isScrolled}
              RestaurantInfo={RestaurantInfo}
              CateGori={RestaurantInfo.categories[0]}
            />
            <Styled.MarginTopBox isFixed={isFixed}/>
            {RestaurantInfo.categories.map((v)=>{
              return(
                <>
                  {/* <Anchor 
                    RestaurantInfo={RestaurantInfo}
                    CateGori={v.names.KR}
                  /> */}
                  <Menu 
                    RestaurantInfo={RestaurantInfo.categories}
                    CateGori={v.names}
                    Langcookies={NowLang}
                  />
                </>
              )
            })}

            {/* <Not /> */}
            <CompanyInfo />
          </>
        )}
        <Styled.Notice visible={showNotification} display={showNotification}>
          <Styled.NoticeText>{Message[NowLang]}</Styled.NoticeText>
        </Styled.Notice>
      </Styled.Wrap>
    ) : 
      <Styled.Wrap ref={wrapRef}>
        <CallService CallOpen={CallOpen} setCallOpen={setCallOpen} NowLang={NowLang} setNowLang={setNowLang} />
        <Lang setLangSetting={setLangSetting} LangSetting={LangSetting} NowLang={NowLang} setNowLang={setNowLang} />
        {isLoading ? (
          <Skeleton />
        ) :<></> }
        {AlertOpen ? (
          <FirstAlert setAlertOpen={setAlertOpen} AlertOpen={AlertOpen} restaurantLocation={restaurantLocation} />
        ) : <></>}
        <TopNot />
        <Styled.Header>
          <Call setCallOpen={setCallOpen} setLangSetting={setLangSetting} NowLang={NowLang} />
        </Styled.Header>


        {isLoading ? (
          <Skeleton /> // 로딩 중일 때 스켈레톤 화면 표시
        ) : (
          <>
            <Table RestaurantInfo={RestaurantInfo} TableInfo={TableInfo} />
            <NewAnchor 
              RestaurantInfo={RestaurantInfo}
              CateGori={RestaurantInfo.categories[0]}
            />
            <Styled.MarginTopBox isFixed={isFixed}/>
            {RestaurantInfo.categories.map((v)=>{
              return(
                <>
                  {/* <Anchor 
                    RestaurantInfo={RestaurantInfo}
                    CateGori={v.names.KR}
                  /> */}
                  <Menu 
                    RestaurantInfo={RestaurantInfo.categories}
                    CateGori={v.names}
                    Langcookies={NowLang}
                  />
                </>
              )
            })}

            {/* <Not /> */}
            <CompanyInfo />
          </>
        )}
        <Styled.Notice visible={showNotification} display={showNotification}>
          <Styled.NoticeText>{Message[NowLang]}</Styled.NoticeText>
        </Styled.Notice>
      </Styled.Wrap>
    )
};

export default Order;